// extracted by mini-css-extract-plugin
export var colDescription = "styles-module--col-description--GXoE5";
export var colLogo = "styles-module--col-logo--9KmDq";
export var customer = "styles-module--customer--mqe2N";
export var image = "styles-module--image--V+Dx2";